import { render, staticRenderFns } from "./McnTaskFollowRoom.vue?vue&type=template&id=340a1589&scoped=true&"
import script from "./McnTaskFollowRoom.vue?vue&type=script&lang=js&"
export * from "./McnTaskFollowRoom.vue?vue&type=script&lang=js&"
import style0 from "./McnTaskFollowRoom.vue?vue&type=style&index=0&id=340a1589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340a1589",
  null
  
)

export default component.exports